import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreloginGuard } from 'common/guards/prelogin.guard';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                loadChildren: () => import('./welcome/welcome.module').then((m) => m.WelcomePageModule),
            },
            {
                path: 'login',
                loadChildren: () => import('./login/login.module').then((m) => m.LoginPageModule),
            },
            {
                path: 'view-certificate',
                loadChildren: () => import('./view-cirtificate/view-cirtificate.module').then((m) => m.ViewCirtificatePageModule),
            },
            {
                path: 'empanelment',
                loadChildren: () => import('./empanelment/empanelment.module').then((m) => m.EmpanelmentPageModule),
            },
            {
                path: 'view-content/:contentId/:userId',
                loadChildren: () => import('./view-content/view-content.module').then((m) => m.ViewContentPageModule),
            },
            {
                path: '**',
                redirectTo: '',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PreloginPageRoutingModule {}
